import assert from 'assert';
import util from 'util';
import HRN from 'human-readable-numbers';
import SimpleDateFormat from "@riversun/simple-date-format";
import {Loading, Message} from 'element-ui';
import {vue} from "./main";
var parseBool = require('parseboolean');

const SDF = new SimpleDateFormat();
const DATE_FORMATE_TEMPLATE = 'yyyy-MM-dd HH:mm:ss'
const DATE_FORMATE_TEMPLATE_2 = 'yy-MM-dd HH:mm:ss'
const DATE_FORMATE_TEMPLATE_3 = 'yyyy-MM-dd'
const DATE_FORMATE_TEMPLATE_4 = 'yy-MM-dd'

export class DateFormat{

    /**
     * @param {String|Date} date
     */
    static stdFormat(date){
        if(typeof date === 'string'){
            date = new Date(date);
        }
        return SDF.formatWith(DATE_FORMATE_TEMPLATE, date);
    }

    /**
     * simply the year
     * @param date
     */
    static simYearStdFormat(date){
        if(typeof date === 'string'){
            date = new Date(date);
        }
        return SDF.formatWith(DATE_FORMATE_TEMPLATE_2, date);
    }

    static yYMmDdFormat(date){
        if(typeof date === 'string'){
            date = new Date(date);
        }
        return SDF.formatWith(DATE_FORMATE_TEMPLATE_3, date);
    }

    static simYearYyMmDdFormat(date){
        if(typeof date === 'string'){
            date = new Date(date);
        }
        return SDF.formatWith(DATE_FORMATE_TEMPLATE_4, date);
    }

    /**
     * 如果是 PC 和 pad 端使用 yYMmDdFormat 如果是手机端使用 simYearYyMmDdFormat
     */
    static responsiveYyMmDdFormat(date){
        if(isMiniPhoneAgent()){
            return DateFormat.simYearYyMmDdFormat(date);
        }else{
            return DateFormat.yYMmDdFormat(date);
        }
    }

}

export class Constants{

    static get redColor(){
        return '#CB0101'
    }

    static get purpleColor(){
        return '#5F04B4'
    }

    static get deepPurpleColor(){
        return '#210B61'
    }

    static getPinkBackgroundColor(){
        return '#FDF7F6';
    }

    static getPinkBorderColor(){
        return '#f7dae7';
    }

    static get blackColor(){
        return '#303133';
    }

    static get accessTokenName(){
        return 'access_token'
    }

    // 尺寸低于 350 的视作是 mini phone
    static get miniPhoneWidth(){
        return 350
    }

    static get officalSite(){
        return 'www.huocool.com'
    }

    static get officalEmail(){
        return 'huocool.service@gmail.com'
    }

    /* 以下参数是用来处理 iap 支付丢单的问题  */

    static get iAPRestoreFlag(){
        return 'restoreFlag'
    }

    static get iAPShortcode(){
        return 'iap_shortcode';
    }

    static get iAPPrice(){
        return 'iap_price';
    }

    /* 以下参数是用来处理 iap 支付丢单的问题 END */

}

export const ShowEntityMode = {
    SinglePageMode: 1,
    PopupPageMode: 2
}

export const EntityType = {
    SinglePic: { name: '图片' },
    SingleVideo: { name: "视频" },
    ImageSets: {name: "图集"}
}

export const isWebAgent = () => {
    return !isMobileAgent();
}

export const isMobileAgent = () => {
    let userAgent = navigator.userAgent.toLowerCase()
    // console.log('user agent:', userAgent)
    // if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
    if (/iphone|android|ipad|pad/i.test(userAgent)) {
        return true
    } else {
        return false
    }
}


/**
 * 直接在手机端真机上执行，拿到的 user agent 是 mozilla/5.0 (iphone; cpu iphone os 14_0_1 like mac os x) applewebkit/605.1.15 (khtml, like gecko) mobile/15e148 html5plus/1.0
 * @return {boolean}
 */
export const isPhoneAgent = () => {
    let userAgent = navigator.userAgent.toLowerCase();
    // console.log('user agent:', userAgent)
    // if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
    if (/iphone|android/i.test(userAgent)) {
        return true
    } else {
        return false
    }
}

export const isIosClient = () => {
    let userAgent = navigator.userAgent.toLowerCase();
    // console.log('user agent:', userAgent)
    // if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
    if (/iphone|ipad/i.test(userAgent)) {
        return true
    } else {
        return false
    }
}

export const isMiniPhoneAgent = () => {
    if (isPhoneAgent()){
        if (getMaxScreenWidth() <= Constants.miniPhoneWidth )
            return true;
    }
    return false
}

export const isHtml5PlusSupported = () => {
    if( navigator.userAgent.indexOf("Html5Plus") < 0){ // 不支持 5+ API
        return false
    }else{
        return true
    }
}

export const isHybridAgent = () => {
    return isHtml5PlusSupported();
}

// 是否是 native ios client
export const isNativeIosAgent = () => {
    return isHtml5PlusSupported() && isIosClient();
}

export const isH5PhoneAgent = () => {
    return isPhoneAgent() && !isHybridAgent();
}

export const isExpectedSpider = () => {
    let userAgent = navigator.userAgent.toLowerCase();
    return (/Baiduspider|bingbot|Sosospider|Sogou Pic Spider|360Spider/i.test(userAgent))
}


// https://stackoverflow.com/questions/1248081/how-to-get-the-browser-viewport-dimensions
// screen height 包含了手机 status bar 的高度，不过这个高度只有在 hybrid 的环境下有效。
export const getMaxScreenHeight = () => {
    return Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0, screen.height || 0)
}

export const getMaxScreenWidth = () => {
    return Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0, screen.width || 0);
}

export class Entity{
    /**
     *
     * @param {Object} e, the entity
     */
    static getType(e){
        if(e.is_video){
            return EntityType.SingleVideo;
        }else{
            if(e.slots.length == 1){
                return EntityType.SinglePic;
            }else{
                return EntityType.ImageSets;
            }
        }
    }
}

export class Comment{

    /**
     * @param shortcode
     * @param threadId
     * @return {comment}
     */
    static getThread(shortcode, threadId){
        let mainComments = vue.$store.getters.getComments(shortcode);
        for(let mc of mainComments){
            // 1. find this in main comments
            if(mc.id === threadId){
                console.log('find self return:', mc.id);
                return mc;
            }
            // 2. continue searching in child comments.
            if(mc.threads !== undefined && mc.threads !== null && mc.threads.length > 0){
                for(let c of mc.threads ){
                    console.log(`child comment id: ${c.id}`);
                    if(c.id === threadId){
                        console.log('find self return:', c.id);
                        return c;
                    }
                }
            }
        }
        throw null;
    }

}

export class User{

    static set token(token){
        window.localStorage.setItem(Constants.accessTokenName, token);
        console.log(`token ${token} has been saved into client`);
    }

    /**
     *
     * @return {string|null}
     */
    static get token(){
        return window.localStorage.getItem(Constants.accessTokenName);
    }

    static removeToken(){
        window.localStorage.removeItem(Constants.accessTokenName);
        console.log('the token get purged');
    }
}

export class Styles {

    /**
     * 手机端，有很多层弹窗，而每个弹窗都会试图去禁止 body scroll，关闭的时候试图激活 body scroll，然后，激活 body scroll 应该由最后一层
     * 弹窗操作，否则上面的弹窗激活 body scroll 后导致下面的弹窗的禁用 body scroll 失效。现在想到的最简单直观的做法是，
     * 添加一个 body scroll lock。
     */
    static __bodyScrollLocked = false;

    static get bodyScrollLocked(){
        return Styles.__bodyScrollLocked;
    }

    static set bodyScrollLocked(val){
        Styles.__bodyScrollLocked = val;
        console.log('Styles, body scroll, the bodyScrollLocked has been set as', val);
    }

    // 想了想，disable 没有必要判断 bodyScrollLocked。只要保证它不被 enabled 就好。
    static disableBodyScroll(){
        const body = document.querySelector("body");
        body.style.overflow = 'hidden';
        console.log('body scroll has been disabled');
    }

    static enableBodyScroll(){
        if(!Styles.bodyScrollLocked){
            const body = document.querySelector("body");
            body.style.overflow = 'auto';
            console.log('body scroll has been enabled');
        }else{
            console.log('body scroll has been locked, can not be enabled');
        }
    }

    /**
     * to check if the element ellipsised or not
     * @param id (Element id)
     */
    static isEllipsis(id){
        var e = document.getElementById('location');
        console.log(e.offsetWidth, e.scrollWidth)
        if(e.offsetWidth < e.scrollWidth){
            console.log('the location is ellipsis');
            return true;
        }else{
            console.log('the location is NOT ellipsis');
            return false;
        }
    }

}


export class HTML {
    /**
     * copy the <input id> values.
     * 备注，这是通用的方法，但是需要定义一个 input 元素才可以。并且 input 元素不可隐藏！如果不想展示该 input 元素，使用绝对定位，将其放置到
     * 千里之外去，比如 position: fixed; top: -1000px; left: -1000px;
     * @param id
     */
    static copy(id){
        console.log('ContactUs copy, to copy the input', id);
        var copyText = document.getElementById(id);

        /* Select the text field */
        copyText.select();
        copyText.setSelectionRange(0, 900); /* For mobile devices */

        /* Copy the text inside the text field */
        document.execCommand("copy");
    }

    /**
     * 通过 Async Clipboard API 完成拷贝，不需要 input 元素
     * 参考 https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript
     * @param shortcode
     * @deprecated 很可惜，这种方式在 Hybrib app 上不被支持
     */
    static __copy(shortcode){
        console.log('execute copy() with', shortcode);
        if (navigator.clipboard !== undefined){
            navigator.clipboard.writeText(shortcode).then(function() {
                console.log('Async: Copying to clipboard was successful!');
                successMessage('复制成功');
            }, function(err) {
                console.error('Async: Could not copy text: ', err);
                errorMessage('复制失败');
            });
        } else{
            this.__copy();
        }
    }
}

/**
 * 全局 loading，respect body scroll behaviors
 */
export class GlobalLoading {

    static loading = null;

    static start(){
        console.log('global loading start');
        GlobalLoading.loading = loadingInstance();
        Styles.disableBodyScroll();
        // 还是有隐患，试想，如果用户 route 成功，然后在新的页面因为其它的业务 global loading 开始了，然后 timeout 把 global loading 却结束了。
        // setTimeout(()=>{
        //     console.log('exceeds 10 sec, timeout to stop the global loading');
        //     GlobalLoading.stop();
        // }, 10000); // 必须给一个超时时间，否则可能屏幕会被 spinner 假死。
    }

    static stop(){
        if(GlobalLoading.loading !== null){
            console.log('global loading done!');
            GlobalLoading.loading.close();
            Styles.enableBodyScroll();
            GlobalLoading.loading = null;
        }
    }

}

/**
 * HCF388 suppress the same error message in 3 seconds
 */
class ErrorMessage{

    // {msg: time}  key: msg, value: time
    static errors = new Object();
    static tolerance = 3000; // 3ms

    /**
     *
     * @param content
     * @param isCenter
     * @return {ElMessageComponent|null}
     */
    static show(content, isCenter=true){
        if (ErrorMessage.errors[content] !== undefined){ // 表示由相同的 message 存在
            let lastTime = ErrorMessage.errors[content];
            let currTime = Date.now();
            let elapsed = currTime - lastTime; // 过去了多久呢？
            if (elapsed <= ErrorMessage.tolerance ){
                console.log(`ErrorMessage, found the same error content "${content}" and suppress it in 3 secons`)
                ErrorMessage.put(content);
                return null; // suppress the error message
            }
        }
        ErrorMessage.put(content);
        return Message.error({message: content, center: isCenter})
    }

    static put(content){
        ErrorMessage.errors[content] = Date.now();
    }

}

// 注意，这里初始化得到的 loadingInstance 是全局唯一的，参考官网说明 https://element.eleme.cn/#/zh-CN/component/loading#fu-wu
// loadingInstance margin-top 50px 的目的是为了避免将 header 也给遮蔽了。
let loadingCustomClass = '';
let messageCustomClass = '';
if( isPhoneAgent() ){
    loadingCustomClass = 'margin-top-50px';
    messageCustomClass = 'margin-top-30px';
}
export var loadingInstance = (text='') => {return Loading.service({fullscreen: true, background: 'rgba(0, 0, 0, 0.7)', lock: true, text: text, customClass: loadingCustomClass})};
export var infoMessage = (content, isCenter=true) => {return Message.info({message: content, center: isCenter, customClass: messageCustomClass})};
export var successMessage = (content, isCenter=true) => {return Message.success({message: content, center: isCenter, customClass: messageCustomClass})};
export var warningMessage = (content, isCenter = true) => {return Message.warning({message:content, center:isCenter, customClass: messageCustomClass})};
export var errorMessage = (content, isCenter=true) => {return ErrorMessage.show(content, isCenter)};

/**
 * TODO 下面的这种逐层找到 login component 的方式太过于笨拙，最好能够写一个通用的方法来找；另外，这个方法要能够工作，任何一个 component
 *  的层级关系都不能变!
 *
 * @return {Vue | Element | Vue[] | Element[]}
 * @return the my header component
 */
export var getMyHeader = function(){
    let app = vue.$children[0];
    let mainContainer = app.$children[0];
    let elHeader = mainContainer.$children[0];
    let myHeader = elHeader.$children[0];
    console.log('my header:', myHeader);
    return myHeader;
}

export var getWallpaperPreviewerImageComp = function(){
    let app = vue.$children[0];
    return app.$refs.wallpaperPreviewerImage;
}

/**
 * TODO 下面的这种逐层找到 login component 的方式太过于笨拙，最好能够写一个通用的方法来找；另外，这个方法要能够工作，任何一个 component
 *  的层级关系都不能变!
 *
 * @return {Vue | Element | Vue[] | Element[]}
 * @return the login component
 */
export var getLoginComponent = ()=>{
    let myHeader = getMyHeader();
    let loginComponent = myHeader.$refs.login;
    console.log('login component:', loginComponent);
    return loginComponent;
}

export var getMenuComponent = ()=>{
    let myHeader = getMyHeader();
    let menuComponent = myHeader.$children[1];
    console.log('menu component:', menuComponent);
    return menuComponent;
}

export var showLoginComponent = () => {
    getLoginComponent().show();
}

// TODO, rename this to be getSignedInUser..
export var getCachedUser = () => {
    let cachedUser = vue.$store.getters.getUser();
    console.log('get cached user', cachedUser);
    return cachedUser;
}


function removeTargetScriptNode(regexStr){
    let targetToRemove = null
    for( let s of document.getElementsByTagName("script") ){
        if (regexStr.test(s.src)){
            console.log('find the matched element to be removed, ', s);
            targetToRemove;
        }
    }
    if (targetToRemove !== null){
        targetToRemove.parentNode.removeChild(targetToRemove);
        console.log(`the element ${targetToRemove} get removed`);
    }
}

/**
 * 因为现在是 SPA，页面不会刷新
 * 1. 当路由切换的时候，才会 push，目前仅有 channel 和 entity 需要 push
 * 2. 不能重复添加相同的 script 节点，否则报错，页面展示异常。因此必须先删除然后追加。
 */
export const pushBaiduSeo = () => {
    try{
        console.info('start to append baidu seo script tag');
        // first to remove,
        removeTargetScriptNode(/bdstatic|zhanzhang/);
        // then add
        var bp = document.createElement('script');
        var curProtocol = window.location.protocol.split(':')[0];
        if (curProtocol === 'https'){
            bp.src = 'https://zz.bdstatic.com/linksubmit/push.js';
        }
        else{
            bp.src = 'http://push.zhanzhang.baidu.com/push.js';
        }
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(bp, s);
        console.info('start to append baidu seo script tag complete');
    } catch(error){
        console.error('pending push baidu fail, error:', error);
    }
}

/**
 * FIXME 现在 SO 的添加后，页面报错，还不知道原因
 */
export const pushSoSeo = () => {
    try {
        console.info('start to append SO seo script tag');
        removeTargetScriptNode(/qihucdn|qhimg/);
        var src = (document.location.protocol == "http:") ? "http://js.passport.qihucdn.com/11.0.1.js?54483cb057c46b0bf9f94a622bb27949" : "https://jspassport.ssl.qhimg.com/11.0.1.js?54483cb057c46b0bf9f94a622bb27949";
        document.write('<script src="' + src + '" id="sozz"><\/script>');
        console.info('start to append SO seo script tag complete');
    } catch(error){
        console.error('pending push SO fail, error:', error);
    }
}

import { confirmIapPayment } from "./data/payment";

/**
 * the common payment helper
 */
export class PaymentHelper {

    /**
     *
     * Note, this method only works for Native app.
     *
     * @param id, the channel id： "alipay" - 表示支付宝； "wxpay" - 表示微信支付； "appleiap" - 表示苹果应用内支付； "qhpay" - 表示360聚合支付（仅360手助流应用环境下支持）。
     * @return Promise<Object>, Object is the channel chosed.
     *
     */
    static fetchTheTargetChannel(id){
        return new Promise( resolve => {
            let channel = null; // the target channel
            plus.payment.getChannels(
                (channels) => {  // 成功回调
                    for (var i in channels) {
                        var c = channels[i];
                        console.log(`=========> channel id: ${c.id}`);
                        if (c.id === id) {
                            console.log(`with id ${id}, the target payment channle found as ${JSON.stringify(c)}`);
                            channel = c;
                            break;
                        }
                    }
                    resolve(channel);
                },
                function(e) { // 失败回调
                    console.error("获取支付通道失败：" + e.message);
                    resolve(null);
                }
            );
        });
    }
}

export class IapHelper{

    static productIds = ['HC_0003', 'HC_0006']; // iAP 的 product ids

    /**
     * html5plus 文档要求必须先执行 iap.requestOrder 方法初始化 iap 支付.
     * 但是有关问题，因为它是异步的，如果在它还没有加载成功的时候，用户发起付款，则无法支付的。但是，这个方法应该只会被初始化一次，因此
     * 单独隔离出来还是值得的。=> 最后验证出来的结果是，每次开启 payment 都需要 init 一次，因此这个方法被 @deprecated 了。放在每次
     * 需要支付的时候才发起请求。
     *
     * 通常这个方法只需要被执行一次；如果执行多次也没问题，但是耗费性能，这也能使为什么这个方法被重构在 App.vue 的 mounted 方法中执行的一大原因
     *
     * @return Promise(Boolean), true if init success else false.
     */
    static initIap(){
        return new Promise(resolve => {
            console.log('call requestOrder to init iAP');
            let channel = vue.$store.state.channel;
            assert.ok(channel !== null, 'the payment channel should not be null');
            // 初始化 iOS apple pay 的商品 ID
            // iap 为刚刚获取的`appleiap`支付通道
            channel.requestOrder(IapHelper.productIds, function(r) {
                // 获取订单信息成功回调方法
                // equestOrder success: [{"description":"火酷APP内购买项目","price":0.99,"pricelocal":"zh_US@currency=USD","productid":"HC_0003","title":"图片下载"},{"description":"火酷APP内购买项目","price":0.99,"pricelocal":"zh_US@currency=USD","productid":"HC_0006","title":"图集或视频下载"}]
                console.log('requestOrder success: return' + JSON.stringify(r));
                resolve(true);
            }, function(e) {
                // 获取订单信息失败回调方法
                console.error('requestOrder failed: ' + JSON.stringify(e));
                resolve(false);
            });
        })
    }

    /**
     *
     * @param channel
     * @return Promise
     */
    static __initIap() {
    }

    /**
     * https://ask.dcloud.net.cn/article/497
     * 这个方法是专门用来处理丢单的问题，典型的是，用户支付成功后，但是苹果迟迟没有发起回调，用户退出 app（可能是等待时间过长）。然后，
     * 用户再返回到 app，这个时候就会产生丢单。因此这个方法是专门用来处理丢单的情况的的
     * 1. 一是在支付响应失败的时候调用
     * 2. 而是在用户返回 app 的时候调用
     *
     * 官方文档，
     * 注意：如果用户在支付过程中退出了 App，或其他情况造成的丢单的消耗类型商品在支付完成后，"首次调用"该接口可返回支付凭证（由苹果发起的回调支付凭证）
     *
     * 我的文档，
     * 注意：一定要使用参数传递 shortcode 和 price，因为如果用户支付过程中，成功支付但没有等待苹果的 feedback，就将 app 完全退出，
     * 注意不是退出后台，而是杀死了整个 app 进程。而后，用户进入 app，这个时候 app 会重新全部刷新，然后随便进入某个 shortcode，则会
     * 触发 restoreCompletionRequest 方法，之前 shortcode 和 price 是通过 this 得到的，则会错误的将这个新的 shortcode 作为了
     * 支付成功的记录了。这是不正确的。因此，正确的做法是，丢单对应的 shortcode 和 price 存放在 Storage 中，恢复订单的时候从 Storage
     * 中获取即可。
     */
    static restoreCompletionRequest(){
        console.log('restoreComplateRequest starts...');
        let restoreFlag = window.localStorage.getItem(Constants.iAPRestoreFlag); // 注意，restoreFlag 取回的是 String 类型
        if ( restoreFlag !== undefined && parseBool(restoreFlag) === true ) { // 只有当有一个正处于支付过程中的交易才会发起一次 restore 的行为
            console.log('assure the restoreFlag is true, start to restore the iap loss one');
            let channel = this.$store.state.channel;
            if (channel === null)
                throw Error('channel is NULL during recovery iap loss');
            window.localStorage.setItem(Constants.iAPRestoreFlag, false);  // 清除标记 restoreFlag = false
            // 调用下面这个方法不行，必须重新发起一次新的支付，才会恢复。
            channel.restoreComplateRequest({}, function (feedback) {
                (async ()=> {
                    // results 格式为数组存放恢复的IAP商品交易信息对象 IAPTransaction，需要将返回的支付凭证传给后端进行二次认证
                    console.log('iap restoreComplateRequest, get the results: ', JSON.stringify(feedback));
                    // 为什么使用 username 作为 attach 字段是因为 Html5Plus 的 payment.request 接口的限制，不允许用户自定义字段。详情参考 Payment.vue iAP payment 的详细描述。
                    let attach = JSON.parse(feedback.payment.username); // attachment, 注意传递的 attach 参数是在返回的 payment 节点下。
                    IapHelper.iAPConfirm(feedback, attach.shortcode, attach.price);
                    plus.nativeUI.alert('之前的订单已经完成，请进入下载列表查看');
                })();
            });
        }
    }

    /**
     * to confirm the payment
     */
    static async iAPConfirm(feedback, shortcode, price){
        // 支付成功，result 为 IAP商品交易信息对象 IAPTransaction 需将返回的支付凭证传给后端进行二次认证
        console.log('payment is success, and results return from appstore: ', JSON.stringify(feedback));
        let client = null;
        let userAgent = navigator.userAgent.toLowerCase();
        if (/iphone/i.test(userAgent)) client = 'iphone';
        if (/ipad/i.test(userAgent)) client = 'ipad';
        let r = await confirmIapPayment(feedback, shortcode, price, client);
        return r;
    }


}

/**
 * 为了方便通过浏览器调试，如果是 web 则使用网络的方式读取 src。约定 src 默认是从本地读取的即是前面没有 '/'。
 *  - update 已经不再兼容 web 的方式了，因此直接返回 src 即可
 */
export const adaptPic = (src) => {
    if (process.env.APP_ENV) {
        return src;
    }
    // web 端路径
    else if (process.env.NODE_ENV){
        return '/'+src
    }
}

export class Video {

    static isLandscapeVideo(height, width) {
        let isLandscapeVideo = height <= width * 0.75;
        // console.log(`--------> isLandscapeVideo: ${isLandscapeVideo}`);
        return isLandscapeVideo;
    }
}

export class Device {

    /**
     * @since v2.3.0 每次先从 localStorage 中获取，如果没有获取到再从 Device 中获取，好处是，可以在测试环境中非常方便的注入设备 ID 以
     * 测试各种用户的场景，另外可以简化 web 端注入设备 ID 的逻辑流程。
     *
     * @returns {Promise<String> | String}
     */
    static get deviceId() {
        // return 'E93306FF-A015-43E6-A8A3-F6F69A62B99B'; // 误删！移山计划的测试换机流程，只修改了最后一个字母 A->B。
        let deviceId = window.localStorage.getItem(Constants.deviceId);
        if (deviceId !== undefined && deviceId !== null) return deviceId;
        else {
            return new Promise((resolve, reject) => {
                if (!window.plus) return resolve(null); // 兼容浏览器
                if (isNativeIosAgent()) {
                    plus.device.getInfo({
                        success: function (info) {
                            console.log('================> getDeviceInfo success: ' + JSON.stringify(info));
                            let deviceId = info.duid || info.uuid;
                            if (deviceId !== undefined && deviceId !== null)
                                // 本来都不用存的，但是因为现在 EntityDownload 需要使用，为了避免编程的复杂性，因此暂存把..
                                window.localStorage.setItem(Constants.deviceId, deviceId);
                            resolve(deviceId);
                        },
                        fail: function (e) {
                            console.log('================> getDeviceInfo failed: ' + JSON.stringify(e));
                            resolve(null);
                        }
                    });
                } else if (isNativeAndroidAgent()) {
                    // 获取匿名设备标识符 https://www.html5plus.org/doc/zh_cn/device.html#plus.device.getOAID
                    plus.device.getOAID({
                        success:function(info){
                            console.log('================> getOAID success: '+JSON.stringify(info));
                            deviceId = info.oaid;
                            if (deviceId !== undefined && deviceId !== null)
                                // 本来都不用存的，但是因为现在 EntityDownload 需要使用，为了避免编程的复杂性，因此暂存把..
                                window.localStorage.setItem(Constants.deviceId, deviceId);
                            resolve(deviceId);
                        },
                        fail:function(e){
                            console.log('================> getOAID failed: '+JSON.stringify(e));
                            resolve(null);
                        }
                    });
                } else {
                    resolve(null);
                }
            });
        }
    }

    /**
     *  * iphone SE: 375
     *  * iphone 13 mini: 375
     *  * iphone 13 pro: 390
     *  * iphone 13 pro max: 414
     */
    static get iPhoneProMaxWidth() {
        return 414;
    }

    static get iPhoneProWidth() {
        return 390;
    }

    static get iPhoneMiniWidth() {
        return 375;
    }

    static get iPhoneMiniHeight() {
        return 812;
    }

    static get iPhoneSEWidth() {
        return 375;
    }

    /**
     * @return {number} px
     */
    static get iPadMiniWidth() {
        return 744;
    }

    /**
     * @return {number} px
     */
    static get iPadMiniHeight() {
        return 1133;
    }

    static get iPadAirWidth() {
        return 820;
    }

    static get iPadAirHeight() {
        return 1180;
    }

    static get iPadWidth() {
        return 810;
    }

    static get iPadHeight() {
        return 1080;
    }

    // size for ipad pro 9.7 inch（with touch bar）
    static get iPadPro97InchWidth() {
        return 768;
    }

    // size for ipad pro 9.7 inch（with touch bar）
    static get iPadPro97InchHeight() {
        return 1024;
    }

    // size for ipad pro 11 inch（no touch bar）
    static get iPadPro110InchWidth() {
        return 834;
    }

    // size for ipad pro 11 inch（no touch bar）
    static get iPadPro110InchHeight() {
        return 1194;
    }

    // size for ipad pro 12.9 inch（no touch bar）目前已知的最大尺寸了
    static get iPadPro129InchWidth() {
        return 1024;
    }

    // size for ipad pro 11 inch（no touch bar）目前已知的最大尺寸了
    static get iPadPro129InchHeight() {
        return 1366;
    }

    static getHeaderHeight() {
        return 44;
    }

    static getIosFooterHeightWithNoTouchIcon() {
        return 70;
    }

    static getIosFooterHeightWithTouchIcon() {
        return 48;
    }

    // 提供这个方法的目的主要是为了能够使能浏览器来调试 pad 和手机端
    static isPadSize() {
        return getMaxScreenWidth() >= 736;
    }

    // 经常需要对小尺寸进行进一步的界面调整
    static isPhoneMiniSize() {
        return getMaxScreenWidth() <= Device.iPhoneMiniWidth + 5; // 给 5px 的增幅
    }

    static isMiniPadSize = () => {
        // 注意之前踩过一个坑，按照提示写成了 return 736 <= getMaxScreenWidth() <= 800，而如果这样写了，就永远返回 true 了... 测试如下，
        // > 736 <= 300 <= 800  // 注意返回的是 true
        // 因此只能写作 maxScreenSize >= 736 && maxScreenSize <= 800
        let maxScreenSize = getMaxScreenWidth();
        return maxScreenSize >= 736 && maxScreenSize <= 800
    }

    static get narrowedMaxWidth() {
        return Device.isPadSize() ? narrowMaxWidth : getMaxScreenWidth();
    }

    static get maxScreenWidth() {
        return getMaxScreenWidth();
    }

}






// WEBPACK FOOTER //
// ./src/utils.js